module.exports = __webpack_public_path__ + "img/c_product.f1e42dd0.svg";